import { render } from "./ChromosomeBrowser.vue?vue&type=template&id=61949430&scoped=true"
import script from "./ChromosomeBrowser.vue?vue&type=script&lang=js"
export * from "./ChromosomeBrowser.vue?vue&type=script&lang=js"

import "./ChromosomeBrowser.vue?vue&type=style&index=0&id=61949430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61949430"]])

export default __exports__